import { useMemo } from 'react'

import { InitialConfigType } from '@lexical/react/LexicalComposer'

import { editorNodes } from '../../nodes'
import { useBaseTheme } from '../../themes/base'

export const useLexicalConfig = (): InitialConfigType => {
  const baseTheme = useBaseTheme()

  return useMemo(
    () => ({
      namespace: 'EastcoalEditor',
      theme: baseTheme,
      nodes: editorNodes,
      onError(...args: any[]) {
        console.error('[RichEditor]', ...args)
      }
    }),
    [baseTheme]
  )
}
